import { TutorialTile } from "../../../../shared/tutorial-tiles/model";

import TutorialAnimation from '../../../../shared/tutorial-tiles/components/animations/Filters';

export const TUTORIAL_TILE_KEY = 'streamer-filters';

export const tutorialTileConfig: TutorialTile = {
  titleI18nKey: 'tutorialTiles:streamer:filters:title',
  image: TutorialAnimation,
  items: [
    {
      descriptionI18nKey: 'tutorialTiles:streamer:filters:items:filterYourData:description',
      icon: 'Filter',
      titleI18nKey: 'tutorialTiles:streamer:filters:items:filterYourData:title',
    },
    {
      descriptionI18nKey: 'tutorialTiles:streamer:filters:items:pickValues:description',
      icon: 'CheckListText',
      titleI18nKey: 'tutorialTiles:streamer:filters:items:pickValues:title',
    },
    {
      descriptionI18nKey: 'tutorialTiles:streamer:filters:items:creteRules:description',
      icon: 'FlowChart',
      titleI18nKey: 'tutorialTiles:streamer:filters:items:creteRules:title',
    },
  ],
};
